import { useCallback, useEffect, useRef, useState } from "react";

export function useMobileFullMapOpen(
	isPickerOpen: boolean,
	enablePharmacyMap: boolean,
	closeDropdown: () => void,
) {
	const [isMobileFullMapOpen, setIsMobileFullMapOpen] = useState(false);
	const openingFullMapRef = useRef(false);
	useEffect(() => {
		if (isPickerOpen) {
			return;
		}
		if (!openingFullMapRef.current) {
			setIsMobileFullMapOpen(false);
		}
		openingFullMapRef.current = false;
	}, [isPickerOpen]);
	useEffect(() => {
		if (!enablePharmacyMap) {
			setIsMobileFullMapOpen(false);
		}
	}, [enablePharmacyMap]);
	const handleOpenFullMap = useCallback(() => {
		openingFullMapRef.current = true;
		setIsMobileFullMapOpen(true);
		closeDropdown();
	}, [closeDropdown]);
	const closeFullMap = useCallback(() => {
		setIsMobileFullMapOpen(false);
	}, []);
	return {
		isMobileFullMapOpen,
		setIsMobileFullMapOpen,
		handleOpenFullMap,
		closeFullMap,
	};
}
